module.exports = __webpack_public_path__ + "img/pied-pro-logo-clean.41ea757b.png";